import Link from 'next/link'
import styled from 'styled-components'

export const StyledLonPageHelper = styled.div`
  background: ${({ theme }) => theme.colors.bgBase};
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  .flex-row-around {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-around !important;

    > div {
      flex: 1;
    }
  }

  p {
    margin: 0;
  }
  a,
  button {
    cursor: pointer;
  }
  .row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  .flex-column-center {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }

  .lon-card {
    padding: 0;
    border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorder};
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 20px;
    background: ${({ theme }) => theme.colors.lonCardBgLight};

    .flex-row-between {
      padding: 15px 20px;
      background: ${({ theme }) => theme.colors.lonCardBg};
      &:last-child,
      &:nth-last-child(2) {
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
      }
      /* &:last-child {
        background: ${({ theme }) => theme.colors.lonCardBgLight};
      } */
    }

    &--light {
      background: #fff;
      border: none;

      .flex-row-between {
        background: #fff;
        border: none;
      }

      .button--light,
      a.button--light,
      a.button.button--light {
        background-color: ${({ theme }) => theme.colors.primaryBgLight};
        color: ${({ theme }) => theme.colors.primary};
      }

      .button--dark {
        background-color: ${({ theme }) => theme.colors.primary};
        color: #fff;
      }
    }

    .divider-wrap {
      background: ${({ theme }) => theme.colors.lonCardBg};

      &--light {
        background: transparent;

        .divider {
          width: calc(100% - 40px);
          margin: 0 auto;
        }
      }

      .divider {
        width: calc(100% - 40px);
        margin: 0 auto;
      }
    }
  }

  .lon-cell {
    width: 375px;
    height: 105px;
    background: ${({ theme }) => theme.colors.lonCardBg};
    border: 0.5px solid ${({ theme }) => theme.colors.lonCardBgLight};
    box-sizing: border-box;
    box-shadow: 0px 4px 20px rgba(57, 53, 92, 0.3);
    border-radius: 12px;
    margin: 10px;
    padding: 25px 24px 28px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    dd {
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      opacity: 0.5;
      margin-bottom: 0;
    }
    dt {
      font-weight: bold;
      font-size: 27px;
      line-height: 27px;
      color: #ffffff;
      margin-top: 10px;
    }
  }

  .flex-row-between,
  .flex-row-around {
    width: 750px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    &.dually {
      .mobile-divider {
        display: none;
      }
    }

    dd {
      font-size: 11px;
      line-height: 13px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-bottom: 0;
    }

    dt {
      font-weight: bold;
      font-size: 17px;
      line-height: 21px;
      color: #ffffff;
      margin-top: 9px;
      margin-bottom: 2px;
    }

    button,
    a.button {
      margin: 0;
      border: 0;
      outline: none;
      height: 32px;
      border-radius: 16px;
      font-size: 15px;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      background: ${({ theme }) => theme.colors.lonCardBtnBg};
      padding: 0 15px;
      cursor: pointer;
      white-space: nowrap;
      display: inline-block;

      &.primary {
        background: ${({ theme }) => theme.colors.primary};
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        padding: 0 45px;
      }
    }
  }

  .exchange-header-wrap {
    background: white;
  }

  .normal-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    width: 1200px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.lonCardDivider};
    margin: 15px 0;

    &.light {
      background: white;
      opacity: 0.05;
      width: calc(100% - 40px);
    }

    &.gray {
      background-color: ${({ theme }) => theme.colors.lonCardDividerLight};
    }
  }

  .footer-wrap {
    background: white;
    a {
      text-decoration: none;
    }
  }

  .lon-inner-wrap {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0 80px;
    flex: 1;
  }
  .sub-nav {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
  }
  dt.reward-value {
    color: ${({ theme }) => theme.colors.textContent};
  }
  @media screen and (max-width: 960px) {
    min-height: 100vh;
    .flex-row-between,
    .flex-row-around {
      width: unset;
    }
    .exchange-header-wrap {
      display: none;
    }

    .footer-wrap {
      display: none;
    }

    .lon-inner-wrap {
      width: 100%;
      padding: 0 15px 30px;

      .flex-row-between.dually,
      .flex-row-between.single {
        flex-flow: row wrap;
        > div {
          width: 50%;
        }
        .mobile-divider {
          display: block;
          height: 1px;
          width: 100%;
          background: ${({ theme }) => theme.colors.lonCardBorder};
          margin: 13px 0;
        }
      }

      .lon-card {
        width: 100%;
        > div {
          width: 100%;
        }
      }
      .mine {
        .lon-cell {
          width: 100% !important;
        }
      }
    }

    dt.reward-value {
      color: ${({ theme }) => theme.colors.textContent};
    }
  }
`

export const StyledLonDashboard = styled.div`
  margin: 0 auto;
  position: relative;
  background: ${({ theme }) => theme.colors.bgBase};
  padding: 0 10px 20px;
  width: 100%;
  margin-bottom: 77px;

  .lon-dashboard-inner {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 43px;
  }
  #tokenlon-modal {
    position: absolute;
    top: 18%;
  }
  h3,
  p {
    margin: 0;
  }

  .lon-cell {
    background-color: #fff;
    border: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
    box-shadow: none;
    color: ${({ theme }) => theme.colors.textTitle};

    dd {
      color: ${({ theme }) => theme.colors.textTertiary};
      opacity: 1;
    }

    dt {
      color: ${({ theme }) => theme.colors.textTitle};
    }
  }

  .logo-wrap {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    color: white;
    padding: 15px;

    > div:first-child {
      background: white;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      padding: 8px;
      box-sizing: border-box;
      img {
        width: 40px;
        height: 40px;
      }
    }

    .name-wrap {
      margin-top: 10px;
      .title {
        font-weight: 800;
        font-size: 17px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.lonCardBg};
      }
      .subtitle,
      .divider {
        font-size: 15px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.textMuted};
      }
      .subtitle {
        margin-left: 0;
      }
      .divider {
        margin: 0 5px;
      }
    }

    .round-time {
      font-size: 11px;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-top: 8px;
    }
  }

  .divide-title {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${({ theme }) => theme.colors.textMuted};
    margin: 30px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
  }

  .overview {
    .overall {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
      padding-left: 10px;
    }

    .mine,
    .mining {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
      padding-left: 10px;
      .lon-cell {
        dt {
            color: ${({ theme }) => theme.colors.rewardGold};
        }

        &.red {
          dt {
            color: ${({ theme }) => theme.colors.statusRed};
          }
          button {
            color: ${({ theme }) => theme.colors.statusRed};

            &.primary {
              color: #fff;
              padding: 0 18px;
              background-color: ${({ theme }) => theme.colors.textBrand};
              border-radius: 45px;
            }
          }
        }
        .tip {
          font-size: 27px;
          line-height: 27px;
          color: #999;
          margin-top: 10px;
          cursor: pointer;
        }
        .status-pill {
          background: rgba(255, 255, 255, 0.7);
          line-height: 20px;
          padding: 0 10px;
          border-radius: 10px;
            color: ${({ theme }) => theme.colors.rewardGold};
          display: inline-block;
          font-size: 12px;
          margin-left: 5px;
        }

        button {
          border: 0;
          outline: none;
          height: 32px;
          line-height: 32px;
          border-radius: 16px;
          padding: 0 30px;
          background: rgba(255, 255, 255, 0.4);
          color: rgba(255, 255, 255, 0.7);
          font-size: 15px;
        }
      }
    }

    .mining {
      display: flex;
      flex-flow: row wrap;
      align-items: center;

      .mining-cards {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
      }
      .mining-card {
        cursor: pointer;
        height: 105px;
        position: relative;

        > div {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;

          .m-icon {
            width: 55px;
            height: 55px;
          }

          p {
            align-items: center;
            color: ${({ theme }) => theme.colors.textTitle};
            display: flex;
            font-size: 21px;
            font-weight: 500;
            letter-spacing: 0.02em;
            line-height: 21px;
            margin-left: 16px;
          }
        }

        &.inactive {
          p,
          img {
            opacity: 0.2;
          }
        }

        &:active,
        &:focus {
          &::after {
            background: ${({ theme }) => theme.colors.textTitle};
            border-radius: 12px;
            content: '';
            height: 100%;
            left: 0;
            opacity: 0.15;
            position: absolute;
            top: 0;
            width: 100%;
          }
        }
      }
    }
  }
  @media screen and (max-width: 960px) {
    -webkit-overflow-scrolling: touch;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px 80px 10px;

    .logo-wrap > div:first-child {
      width: 45px;
      height: 45px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .lon-dashboard-inner {
      width: 100%;
      min-width: unset;
      margin-top: 0;
    }

    .logo-wrap {
      flex-flow: row nowrap;
      .name-wrap {
        flex-flow: column nowrap;
        align-items: flex-start;
        padding-left: 15px;
        span:nth-child(2) {
          display: none;
        }
      }
    }

    .row {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;

      .event-time {
        font-size: 12px;
        line-height: 17px;
        color: rgba(255, 255, 255, 0.7);
        margin-left: 10px;
      }
    }

    .row-start {
      justify-content: flex-start;
      padding: 10px 0;
    }

    .divide-title {
      margin: 20px 0;
      font-size: 11px;
      line-height: 16px;
    }

    .card {
      background: ${({ theme }) => theme.colors.lonCardBg};
      border: 0.5px solid ${({ theme }) => theme.colors.lonCardBorderLight};
      box-sizing: border-box;
      border-radius: 12px;
      padding: 20px 20px 25px 20px;
      height: 85px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .col {
        .key {
          font-size: 11px;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.textTertiary};
        }

        .value {
          font-size: 21px;
          line-height: 22px;
          color: white;
          font-weight: bold;
          margin-top: 5px;
        }

        .status-pill {
          background: rgba(255, 255, 255, 0.7);
          line-height: 20px;
          padding: 0 10px;
          border-radius: 10px;
            color: ${({ theme }) => theme.colors.rewardGold};
          display: inline-block;
          font-size: 12px;
          margin-left: 5px;
        }
      }

      .status-pill-wrap {
        .status-pill {
          margin-top: 0;
        }
      }

      &.minted {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
      }

      &.tokenlon-vol {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
      }

      &.tip-card {
        .key {
          color: ${({ theme }) => theme.colors.borderDefault};
        }
        .tip {
          font-size: 27px;
          line-height: 27px;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 10px;
          cursor: pointer;
        }
      }

      &.my-share {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        background: ${({ theme }) => theme.colors.rewardGold};

        .col {
          .key {
            color: ${({ theme }) => theme.colors.borderDefault};
          }
        }
      }

      &.this-week {
        margin-top: 10px;
        background: ${({ theme }) => theme.colors.statusRed};

        .col {
          .key {
            color: ${({ theme }) => theme.colors.borderDefault};
          }
          .status-pill {
            color: ${({ theme }) => theme.colors.statusRed};
          }
        }
      }

      &.faq {
        margin-top: 10px;
        height: 60px;
        padding: 20px;
        text-decoration: none;
        color: white;
        span {
          font-size: 15px;
          line-height: 21px;
          color: #ffffff;
          text-decoration: none;
        }
      }

      &.records {
        background: ${({ theme }) => theme.colors.primary};
        margin-top: 10px;
        padding: 20px;

        .reward-record {
          width: 100%;
          text-decoration: none;
          p {
            font-weight: bold;
            font-size: 21px;
            line-height: 21px;
            color: #ffffff;
          }
        }
      }
    }

    .overview {
      .overall {
        padding: 0;
        .lon-cell {
          width: 100%;
          height: 85px;
          box-sizing: border-box;
          margin: 5px 10px;

          div {
            dd {
              font-size: 11px;
              line-height: 16px;
              margin-bottom: 0;
            }
            dt {
              font-size: 21px;
              line-height: 21px;
              margin-top: 6px;
            }
          }

          &:last-child,
          &:nth-last-child(2),
          &:nth-last-child(3) {
            display: none;
          }
        }
      }
      .divide-title {
        margin-bottom: 12px;
      }
      .mine {
        padding-left: 0;
        padding-bottom: 0;
        .lon-cell {
          height: 85px;
          width: 100%;
          &.red {
            margin-top: 0;
          }
          div {
            dd {
              font-size: 11px;
              line-height: 16px;
            }
            dt {
              font-size: 21px;
              line-height: 21px;
              margin-top: 10px;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .mining {
        padding: 0 5px;
        .lon-cell {
          padding: 20px 15px;
          height: 85px;
          margin-left: 0;
          &.mining-card {
            > div {
              .m-icon {
                width: 36px;
                height: 36px;
              }
              p {
                color: ${({ theme }) => theme.colors.textTitle};
                font-size: 14px;
                font-weight: normal;
                line-height: 21px;
                margin-left: 8px;
              }
            }
          }
        }
        .mining-cards {
          flex-flow: column nowrap;
          justify-content: space-around;
          gap: 16px;
          margin-top: 16px;
          padding: 0;
          width: 100%;

          .mining-card {
            width: calc(100% - 10px);
            margin: 0;
          }
        }
      }
    }
  }
`

export const StyledBadge = styled.span<{ bgColor?: string }>`
  display: inline-block;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  color: #ffffff;
  padding: 2px 8px;
  background: ${({ bgColor, theme }) => (bgColor ? `${bgColor}` : theme.colors.badgeRed)};
  border-radius: 20px;
  margin-top: 12px;
  margin-left: 16px;

  ${({ theme }) => theme.media.sm`
    font-size: 12px;
    margin-top: 8px;
    margin-left: 8px;
  `}
`

export const StyledLink = styled(Link)`
  ${({ theme }) => theme.media.sm`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  `}
`
